module.exports = __webpack_public_path__ + "img/avatar4.bfe46f11.jpg";